/*
 * Where: src/features/howtouse/components/HowToUseHeroSection.js
 * What: Hero section for the how-to-use page.
 * Why: Keep how-to-use copy rendering inside its own feature.
 */
import React from 'react';

function HowToUseHeroSection({ hero }) {
    return (
        <section className="hero-panel compact">
            <p className="hero-badge">{hero.badge}</p>
            <h1>{hero.title}</h1>
            <p className="hero-description">{hero.description}</p>
        </section>
    );
}

export default HowToUseHeroSection;
